<otb-root [ngClass]="theme + '-theme'"></otb-root>
